// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__ny7ay","tab":"ProcedureTabs_tab__UX3Kj"};